import { OpenFolderIcon } from "~/icons/icons";

export const AVAILABLE_STOCK = "AVAILABLE_STOCK";
export const CONSUMED_STOCK = "CONSUMED_STOCK";
export const PART_PRICE = "PART_PRICE";

export const AvailableStockFilterObj = {
  id: AVAILABLE_STOCK,
  name: "Available Stock",
  icon: OpenFolderIcon,
};

export const ConsumedStockFilterObj = {
  id: CONSUMED_STOCK,
  name: "Consumed Stock",
  icon: OpenFolderIcon,
};

export const PartPriceFilterObj = {
  id: PART_PRICE,
  name: "Price",
  icon: OpenFolderIcon,
};

/** Stock/price filters — only when inventory stock management is enabled. */
export const inventoryStockDefaultFilters = [
  AvailableStockFilterObj,
  ConsumedStockFilterObj,
  PartPriceFilterObj,
];
